/**
 * The function `formatTimestampToYyyyMmDd` converts a timestamp to the yyyy/mm/dd format.
 * @param timestamp - The `timestamp` parameter in the `formatTimestampToYyyyMmDd` function should be a
 * Unix timestamp, which represents the number of milliseconds that have elapsed since January 1, 1970,
 * 00:00:00 UTC. This function converts this timestamp into a date string
 * @returns The function `formatTimestampToYyyyMmDd` takes a timestamp as input, converts it to a Date
 * object, extracts the year, month, and day in UTC format, and then formats them as yyyy/mm/dd. The
 * function returns a string in the format "yyyy/mm/dd".
 */
// Function to convert a timestamp to yyyy/mm/dd format
export const convertDate = (timestamp: string | null | undefined): string => {
  if (!timestamp) {
    return ''; // Return an empty string if timestamp is null, undefined, or empty
  }

  // Create a Date object from the timestamp
  const date = new Date(timestamp);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return ''; // Return an empty string for invalid timestamps
  }

  // Extract year, month, and day in UTC
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
export function formatDateToDDMMYYYY(dateString: string): string {
  // Create a Date object from the input string
  const date = new Date(dateString);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date string provided');
  }
  
  // Get day, month, and year
  // getDate() returns the day of the month (1-31)
  // getMonth() returns the month (0-11), so we add 1
  // getFullYear() returns the year (four digits)
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  // Return the formatted date
  return `${day}-${month}-${year}`;
}

// Example usage:
// const formattedDate = formatDateToDDMMYYYY('2025-03-15T00:00:00.000Z');
// Result: "15-03-2025"

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  if(isNaN(date.getTime())){
    return '-';
  }
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(",", ""); // Remove any comma if present
};

//date and time fucntion
export function convertTimestamp(isoString:any) {
  const date = new Date(isoString);

  // Extract date components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  // Extract time components
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  
  // Convert 24-hour to 12-hour format properly
  if (hours === 0) {
      hours = 12; // Midnight case
  } else if (hours > 12) {
      hours -= 12; // Convert PM hours correctly
  }
  return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
}
export function convertToISOFormat(dateStr: string): string {
  const [day, month, year] = dateStr.split("-");
  return `${year}-${month}-${day}`;
}
